import { AxiosResponse } from 'axios';
import { downloadBlob } from './dom';
import { getFilenameFromHeaders } from './http';
import { camelizeKeys } from './object';

export const downloadResponse = (
    response: AxiosResponse,
    fallbackName: string
): void => {
    return downloadBlob(
        response.data,
        getFilenameFromHeaders(response.headers, fallbackName)
    );
};

export const blobToObject = async (
    response: AxiosResponse,
    camelize = true
): Promise<AxiosResponse> => {
    const isJsonBlob = (data: unknown) =>
        data instanceof Blob && data.type === 'application/json';
    const responseData = isJsonBlob(response?.data)
        ? await response?.data?.text()
        : response?.data || {};
    const responseJson =
        typeof responseData === 'string'
            ? JSON.parse(responseData)
            : responseData;
    const data = camelize ? camelizeKeys(responseJson) : responseJson;
    return { ...response, data } as AxiosResponse;
};
